import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';

export const UserInfo = ({ user }) =>
	<div>
		{user &&
			<div>
				<label className="user-search-label">
					<FormattedMessage id="impersonation.informationFoundText" />
				</label>
				<div className="container UserInfo">
					<div className="row UserInfo__Item">
						<div
							className="col-md-5 col-sm-5 col-xs-5 UserInfo__Item--title"
							id="UserInfoBPNLabel"
						>
							<FormattedMessage id="impersonation.lnBusinessPartnerLabel" />{' '}
						</div>
						<div
							className="col-md-7 col-sm-7 col-xs-7 UserInfo__Item--value"
							id="UserInfoBPNValue"
						>
							{user.bpnumber}
						</div>
					</div>

					<div className="row UserInfo__Item">
						<div
							className="col-md-3 col-sm-3 col-xs-3 UserInfo__Item--title"
							id="UserInfoNameLabel"
						>
							<FormattedMessage id="impersonation.nameLabel" />{' '}
						</div>
						<div
							className="col-md-9 col-sm-9 col-xs-9 UserInfo__Item--value"
							id="UserInfoNameValue"
						>
							{user.last_name}, {user.first_name} {user.middle_name}
						</div>
					</div>

					<div className="row UserInfo__Item">
						<div
							className="col-md-3 col-sm-3 col-xs-3 UserInfo__Item--title"
							id="UserInfoManagerLabel"
						>
							<FormattedMessage id="impersonation.managerLabel" />{' '}
						</div>
						<div
							className="col-md-9 col-sm-9 col-xs-9 UserInfo__Item--value"
							id="UserInfoManagerValue"
						>
							{user.sales_details.manager_name}
						</div>
					</div>

					<div className="row UserInfo__Item">
						<div
							className="col-md-3 col-sm-3 col-xs-3 UserInfo__Item--title"
							id="UserInfoPhoneLabel"
						>
							<FormattedMessage id="impersonation.phoneLabel" />{' '}
						</div>
						<div
							className="col-md-9 col-sm-9 col-xs-9 UserInfo__Item--value"
							id="UserInfoPhoneValue"
						>
							{user.phone}
						</div>
					</div>

					<div className="row UserInfo__Item">
						<div
							className="col-md-3 col-sm-3 col-xs-3 UserInfo__Item--title"
							id="UserInfoEmailLabel"
						>
							<FormattedMessage id="impersonation.emailLabel" />{' '}
						</div>
						<div
							className="col-md-9 col-sm-9 col-xs-9 UserInfo__Item--value"
							id="UserInfoEmailValue"
						>
							{user.email}
						</div>
					</div>

					<div className="row UserInfo__Item">
						<div
							className="col-md-3 col-sm-3 col-xs-3 UserInfo__Item--title"
							id="UserInfoStatusLabel"
						>
							<FormattedMessage id="impersonation.statusLabel" />{' '}
						</div>
						<div
							className="col-md-9 col-sm-9 col-xs-9 UserInfo__Item--value"
							id="UserInfoStatusValue"
						>
							{user.status}
						</div>
					</div>
				</div>
			</div>}
	</div>;

UserInfo.propTypes = {
	user: PropTypes.shape({
		full_name: PropTypes.string,
		country: PropTypes.shape({
			name: PropTypes.string,
		}),
		bpnumber: PropTypes.string,
		sales_details: PropTypes.shape({
			manager_name: PropTypes.string,
		}),
		phone: PropTypes.string,
		email: PropTypes.string,
	}),
};

UserInfo.defaultProps = {
	user: null,
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/ui/components/Impersonation/UserInfo.js